import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCsmPlanning extends Layout {
    source1: DataSource;
    tableCsmMovements: Table;
}
